import { createContext, useContext } from "react";
import type { Content } from "./types";

export interface ContentState {
  content: Content | null;
  error: string | null;
}

export const ContentContext = createContext<ContentState>({ content: null, error: null });

export function useContent(): Content {
  const { content, error } = useContext(ContentContext);
  if (error) throw new Error(error);
  if (!content) throw new Error("内容尚未加载");
  return content;
}

export function useContentState(): ContentState {
  return useContext(ContentContext);
}
